module.exports = [{"id":1,"name":"A3","width":29.7,"length":42,"size_qcm":1247.4},{"id":2,"name":"A4","width":21,"length":29.7,"size_qcm":623.7},{"id":3,"name":"A5","width":14.8,"length":21,"size_qcm":310.8},{"id":4,"name":"A6","width":10.5,"length":14.8,"size_qcm":155.4}]


//////////////////
// WEBPACK FOOTER
// ./src/data/din_printarea.json
// module id = 174
// module chunks = 0